export const RegionalLocaleMapping = {
    eu: 'en-GB',
    na: 'en-US',
    oc: 'en-AU',
};
